var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 0.5H4.5C2.29086 0.5 0.5 2.29086 0.5 4.5V67.5C0.5 69.7091 2.29086 71.5 4.5 71.5H67.5C69.7091 71.5 71.5 69.7091 71.5 67.5V4.5C71.5 2.29086 69.7091 0.5 67.5 0.5Z",
    stroke: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 56H10.5C10.2239 56 10 56.2239 10 56.5C10 56.7761 10.2239 57 10.5 57H61.5C61.7761 57 62 56.7761 62 56.5C62 56.2239 61.7761 56 61.5 56Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 16.3333H17C15.3431 16.3333 14 17.6465 14 19.2666V42.7333C14 44.3533 15.3431 45.6666 17 45.6666H35C36.6569 45.6666 38 44.3533 38 42.7333V25.1333L29 16.3333Z",
    stroke: "#4D4D4D",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 16.3333V25.1333H38",
    stroke: "#4D4D4D",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 29.6667V39.6667",
    stroke: "#4D4D4D",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8891 34.5556L26.0002 29.6667L21.1113 34.5556",
    stroke: "#4D4D4D",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.cbdb2950b8b6beb80ffc6e51d8e1daca.svg";
export { ForwardRef as ReactComponent };